import { EAtmIcon, PaymentLinksIcon, QuickTransferIcon } from '../assets/svg';
import { NonBankCardIcon } from '../assets/svg/NonBankCardIcon';
import { SalesTable } from '../views/payment-links-3/pages/sales/types';
import { CustomLink } from './payment-links-custom';
import { FilterStatus, WithAllFiltersAndPagination } from './table';

export const productTypeMap = new Map<ProductType, JSX.Element>([
	['PL', <PaymentLinksIcon key="payment-link-icon" />],
	['QT', <QuickTransferIcon key="quick-transfer-icon" />],
	['QM', <QuickTransferIcon key="quick-transfer-icon" />],
	['eATM', <EAtmIcon key="eatm-icon" />],
	['TNB', <NonBankCardIcon key="non-bank-card-icon" />],
]);

export interface GraphBanks {
	name: string;
	value: number;
	value_formatted?: string;
}

export interface GraphMethods {
	percentage: string;
	atm: string;
	title: string;
	icon: number;
	comparisons: string;
}

export type ProductType = 'PL' | 'QT' | 'QM' | 'eATM' | 'TNB';
export type PrimitiveStatus = 'pending' | 'success' | 'error' | 'expired';
export type PaymentMethodAllowed = 'SPEI' | 'CoDi' | 'Hites' | 'Tapp' | 'Efectivo';
export type Status =
	| 'active'
	| 'actived'
	| 'aborted'
	| 'authentication_error'
	| 'bank_error'
	| 'cancelled'
	| 'Capturada'
	| 'completed'
	| 'disabled'
	| 'enabled'
	| 'error'
	| 'expired'
	| 'failed'
	| 'finalized'
	| 'inactive'
	| 'inactived'
	| 'in_progress'
	| 'Liquidada'
	| 'liquidated'
	| 'management'
	| 'manual_collection'
	| 'pending_ops'
	| 'pending_retry'
	| 'pending_voucher'
	| 'pending'
	| 'process'
	| 'processing'
	| 'return'
	| 'schedule'
	| 'sent_retry'
	| 'success_merchant'
	| 'success'
	| 'timeout'
	| 'transaction_error'
	| 'waiting_codi';

export interface Payment {
	account: string;
	accountType: string;
	amount: string;
	amountToSearch: string;
	amountWFee?: string;
	bankCode: string;
	bankName: string;
	btstep: string;
	cantidadCuotas?: string;
	clabe: string;
	clientName: string;
	codAutorizacion?: string;
	codiTransferID: string;
	createdatDate: string;
	createdatTime: string;
	descriptionError: string;
	destinationClabe: string;
	fieldResponse?: [
		{
			key: string;
			value: string;
		},
	];
	email?: string;
	expiredate: string;
	expireDate?: string;
	expireTime?: string;
	idx: number;
	lastStep: string;
	paymentConcept: string;
	paymentId: string;
	paymentMethod: PaymentMethodAllowed;
	phone?: string;
	presessiontoken: string;
	presessionName?: string;
	presession: CustomLink;
	productType: ProductType;
	reference: string;
	row_num: number;
	rut: string;
	sessionToken?: string;
	status: Status;
	trackingKey: string;
	transferId?: string;
	typeError?: string;
	urlCEP?: string;
	userClabe: string;
	validatedatDate?: string;
	validatedatTime?: string;
	validationMailPdf?: string;
	verifyCode?: boolean;
	correspondent?: string;
	userName?: string;
}

export interface GraphicsFormat {
	x: string;
	y: string | number;
	x_formatted: string;
	y_formatted: string;
	y_abbr?: string;
}

export interface ResponseGraphics {
	amounts?: GraphicsFormat[];
	data: GraphBanks[];
	others?: GraphBanks[];
	total: number;
	totalAmount?: string;
	paymentMethods?: GraphMethods[];
	hasCash?: boolean;
}

export type PaymentStatus = FilterStatus;

export interface ResponseTable {
	tableInfo: Payment[];
	total: number;
	typeOfStatus: PaymentStatus[];
}

export interface ResponseTablePLSales {
	tableInfo: SalesTable[];
	total: number;
	typeOfStatus: PaymentStatus[];
}
export interface ResponseTableCustomLink {
	tableInfo: CustomLink[];
	total: number;
	typeOfStatus: PaymentStatus[];
}
export interface ResponseExport {
	url: string;
	metadata: ResponseMetadata;
}
export interface ResponseMetadata {
	pdf: string;
}

export interface CommonTableParams extends WithAllFiltersAndPagination {
	merchantCode: string;
	from?: string;
	to?: string;
	international?: boolean;
}
